import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Header from "./app/components/Header";
import Profile from "./app/components/Profile";
import EditProfile from "./app/components/Profile/components/editProfile";
import Signup from "./app/Authentication/signup";
import EmailVerify from "./app/Authentication/emailVerified";
import SignIn from "./app/Authentication/signin";
import MainView from "./app/components/MainView";
import AdminView from "./app/components/AdminView";
import { checkAuth } from "./app/store/loginAction";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    const token = localStorage.token;
    const { pathname } = this.props.location;
    if (token) {
      this.props.getProfile(token, this.props);
    }
    if (
      !token &&
      (pathname === "/profile" ||
        pathname === "/profile?" ||
        pathname === "editprofile")
    ) {
      this.props.history.push("/signin");
    }
    if (
      pathname === "/" ||
      (token && (pathname === "/signin" || pathname === "/signup"))
    ) {
      this.props.history.push("/ringtones-wallpapers");
    }
  }

  onRedirect = path => {
    this.props.history.push(path);
  };

  render() {
    const { pathname } = this.props.location;
    return (
      <div>
        <Header onRedirect={this.onRedirect} path={pathname || ""} />
        <div>
          <Switch>
            <Route path="/ringtones-wallpapers" component={MainView} />
            <Route path="/ringtones" component={MainView} />
            <Route path="/wallpapers" component={MainView} />
            <Route path="/admin" component={AdminView} />
            <Route path="/find" component={MainView} />
            <Route path="/signin" component={SignIn} />
            <Route path="/signup" component={Signup} />
            <Route path="/emailverify" component={EmailVerify} />
            <Route path="/profile" component={Profile} />
            <Route path="/editprofile" component={EditProfile} />
          </Switch>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  getProfile: (token, ownProps) => dispatch(checkAuth(token, ownProps))
});
export default connect(null, mapDispatchToProps)(App);
